import axios from "axios";
import { Tooltip } from "@/components";
import config from '@/config'
const instance = axios.create({
  baseURL:  config.APIEXPLORERURL + 'v1/',
  timeout: 60000
});



instance.interceptors.response.use(
  function(response) {
    if (response.data && response.data.code != 0) {
      Tooltip.error(response.data.msg);
    }
    return response.data;
  },
  function(error) {
    return Promise.reject(error.message);
  }
);
const Http = function({ data = {}, url, params = {}, method }) {
  return instance({
    method,
    url,
    params,
    data,
  });
};

export default Http;
